/**
 * Merges the rankings app's per-concern mixins into the one data object Alpine registers.
 */

/**
 * Copies every own property of each mixin onto a fresh object by descriptor, so getters stay
 * getters instead of being read once the way object spread would. A key defined by two mixins
 * throws: with object literal syntax the later definition used to win silently.
 *
 * @param {...object} mixins Plain objects returned by the mixin factories
 * @return {object}
 */
export const composeMixins = function (...mixins) {
    const target = {};
    for (const mixin of mixins) {
        for (const [key, descriptor] of Object.entries(Object.getOwnPropertyDescriptors(mixin))) {
            if (Object.prototype.hasOwnProperty.call(target, key)) {
                throw new Error(`rankingsApp mixin key "${key}" is defined more than once`);
            }
            Object.defineProperty(target, key, descriptor);
        }
    }
    return target;
};
